import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
   Button, ButtonToolbar, Modal, Alert,
} from 'reactstrap';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import parse from 'html-react-parser';

class ConfirmStockModal extends PureComponent {
   static propTypes = {
      modal: PropTypes.bool,
      toggle: PropTypes.func.isRequired,
      handleChange: PropTypes.func.isRequired,
      handleSubmit: PropTypes.func,
      postValue: PropTypes.oneOfType([
         PropTypes.string,
         PropTypes.shape({
            value: PropTypes.string,
            label: PropTypes.string,
         }),
      ]),
      stockStatus: PropTypes.string,
      errorMsg: PropTypes.string,
   };

   static defaultProps = {
      modal: false,
      handleSubmit: () => {
         console.log('submitted');
      },
      postValue: {},
      stockStatus: '',
      errorMsg: '',
   };

   constructor(props) {
      super(props);
      this.state = {};
      this.isLoading = false;
      this.toggle = this.toggle.bind(this);
   }

   toggle() {
      this.setState(prevState => ({ modal: !prevState.modal }));
   }

   render() {
      const {
         toggle, modal, postValue, handleChange, stockStatus, handleSubmit, errorMsg,
      } = this.props;
      const modalColor = stockStatus && parseInt(stockStatus, 10) === 2 ? 'danger' : 'success';

      return (
         <div>
            <Modal
               isOpen={modal}
               className={`modal-dialog--${modalColor} modal-dialog--header`}
            >
               <div className="modal__header">
                  <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
                  <h4 className="bold-text  modal__title">Confirmation</h4>
               </div>
               <form onSubmit={handleSubmit} id="stocks_form">
                  <div className="modal__body p-t-10">
                  { errorMsg && (
                     <div className="notif_msg">
                        <Alert color="danger" className="alert--colored">
                        {/* <p><span className="fa fa-exclamation">&nbsp;</span> { errorMsg }</p> */}
                        <div className="alert__content">
                           <p>{ parse(errorMsg) }</p>
                        </div>
                        </Alert>
                     </div>
                     )
                  }
                  <div className="form form--vertical m-t-10">
                     {
                        stockStatus && parseInt(stockStatus, 10) !== 2 ? (
                           <div className="form__form-group">
                              <span className="form__form-group-label">Actual Quantity <b className="text-danger">*</b></span>
                              <div className="form__form-group-field">
                                 <input type="text" name="actualQuantity" value={postValue.actualQuantity ? postValue.actualQuantity : ''} placeholder="Actual Quantity" onChange={e => handleChange(e, 'number')} />
                              </div>
                           </div>
                        ) : (
                           <div className="form__form-group">
                              <span className="form__form-group-label">Quantity</span>
                              <div className="form__form-group-field">
                                 <span className="text-success bold fs-17">{postValue.quantity ? `${postValue.quantity} kgs.` : 0}</span>
                              </div>
                           </div>
                        )
                     }
                     <div className="form__form-group">
                        <span className="form__form-group-label">Note
                        {
                           stockStatus && parseInt(stockStatus, 10) === 2 ? (
                              <b className="text-danger m-l-5">*</b>
                           ) : ''
                        }
                        </span>
                        <div className="form__form-group-field">
                           <textarea name="note" value={postValue.note ? postValue.note : ''} className="no-resize mh-120" placeholder="Note" onChange={handleChange} />
                        </div>
                     </div>
                  </div>
                  </div>
                  <ButtonToolbar className="modal__footer">
                     <Button color={modalColor}>Submit</Button>
                     <Button onClick={toggle}>Cancel</Button>
                  </ButtonToolbar>
               </form>
            </Modal>
         </div>
      );
   }
}

export default reduxForm({
  form: 'stockForm',
})(withTranslation('common')(ConfirmStockModal));
